import React, { useEffect } from 'react';
import { useRouter } from 'next/router';
import { getCookie, redirectToLoginPage, replace } from 'utils/common.util';
import useParams from 'hooks/useParams';
import { ProductsRoute } from 'routes/product.routes';

const publicRoutes = [
  '/account/forget-password',
  '/account/forget-password-second-step',
  '/account/login',
  '/account/login-otp-second-step',
  '/account/login-otp',
  '/account/onboarding/',
];

type AuthType = { children: JSX.Element };
const AuthProvider: React.FC<AuthType> = ({ children }): JSX.Element => {
  const router = useRouter();
  const hasToken =
    !!getCookie('pwa_refresh_token') || !!getCookie('pwa_access_token');
  const isPublic = publicRoutes.find((item) => router.asPath.includes(item));
  const { next } = useParams();
  const nextRoute = next || ProductsRoute();

  useEffect(() => {
    !isPublic && !hasToken && redirectToLoginPage();
    isPublic && hasToken && replace(nextRoute.toString())();
  }, [router]);

  return children;
};

export default AuthProvider;
